import React, { useState } from "react";
import * as XLSX from "xlsx";
import { Switch, Alert } from "antd";
import { connect } from "react-redux";
import ImportadorExcelGenerico from "../../../../../Components/ImportadorExcelGenerico";
import ResumenEcommerceModal from "../../ResumenEcommerceModal/ResumenEcommerceModal";
import { encodeId, decodeId } from "../../../../../Components/idEncoder";

const columnasPreview = [
  { title: "Nombre", dataIndex: "nombre", key: "nombre", width: 140 },
  {
    title: "Apellido Paterno",
    dataIndex: "apellidoPaterno",
    key: "apellidoPaterno",
    width: 150,
  },
  {
    title: "Apellido Materno",
    dataIndex: "apellidoMaterno",
    key: "apellidoMaterno",
    width: 150,
  },
  { title: "Correo", dataIndex: "correo", key: "correo", width: 200 },
  { title: "Matrícula", dataIndex: "matricula", key: "matricula", width: 120 },
  {
    title: "Escuela",
    dataIndex: "escuelaNombre",
    key: "escuelaNombre",
    width: 200,
  },
  { title: "Grupo", dataIndex: "grupoNombre", key: "grupoNombre", width: 160 },
  {
    title: "Lista Individual",
    dataIndex: "listaNombre",
    key: "listaNombre",
    width: 180,
  },
  { title: "Tel.", dataIndex: "telefono", key: "telefono", width: 110 },
  { title: "Cel.", dataIndex: "celular", key: "celular", width: 110 },
];

const idStr = (v) => {
  if (!v) return "";
  if (typeof v === "object" && v._id) return String(v._id);
  return String(v);
};


const forzarColumnaTexto = (sheet, colIndex) => {
  if (!sheet || !sheet["!ref"]) return;
  const range = XLSX.utils.decode_range(sheet["!ref"]);
  for (let r = range.s.r + 1; r <= range.e.r; r++) {
    const addr = XLSX.utils.encode_cell({ r, c: colIndex });
    const cell = sheet[addr];
    if (cell && cell.v !== undefined && cell.v !== null && cell.v !== "") {
      cell.t = "s";
      cell.z = "@";
      cell.v = String(cell.v);
    }
  }
};

const COL_MATRICULA = 9;

const construirPlantilla = (catalogos) => {
  const wb = XLSX.utils.book_new();

  const escuelaEjemplo = catalogos.escuelas?.[0]?.nombre || "";
  const grupoEjemplo = catalogos.grupos?.[0]?.nombre || "";
  const listaEjemplo = catalogos.listas?.[0]?.nombre || "";

  const ejemplos = [
    {
      ID: "",
      Nombre: "Juan",
      "Apellido Paterno": "Pérez",
      "Apellido Materno": "García",
      Correo: "juan.perez@example.com",
      Teléfono: "5512345678",
      Celular: "5587654321",
      Escuela: escuelaEjemplo,
      Grupo: grupoEjemplo,
      Matrícula: "MAT-001",
      "Lista Individual": listaEjemplo,
      "Nivel Prepare": "",
      "Nivel Inglés": "",
    },
  ];
  const cabecera = [
    "ID",
    "Nombre",
    "Apellido Paterno",
    "Apellido Materno",
    "Correo",
    "Teléfono",
    "Celular",
    "Escuela",
    "Grupo",
    "Matrícula",
    "Lista Individual",
    "Nivel Prepare",
    "Nivel Inglés",
  ];
  const hojaPrincipal = XLSX.utils.json_to_sheet(ejemplos, { header: cabecera });
  hojaPrincipal["!cols"] = [
    { wch: 22 },
    { wch: 18 },
    { wch: 18 },
    { wch: 18 },
    { wch: 28 },
    { wch: 14 },
    { wch: 14 },
    { wch: 28 },
    { wch: 22 },
    { wch: 16 },
    { wch: 26 },
    { wch: 18 },
    { wch: 14 },
  ];
  forzarColumnaTexto(hojaPrincipal, COL_MATRICULA);
  XLSX.utils.book_append_sheet(wb, hojaPrincipal, "Alumnos");

  const escuelaNombrePorId = new Map(
    (catalogos.escuelas || []).map((e) => [String(e._id), e.nombre || ""]),
  );
  const grupoNombrePorId = new Map(
    (catalogos.grupos || []).map((g) => [String(g._id), g.nombre || ""]),
  );
  const listaNombrePorId = new Map(
    (catalogos.listas || []).map((l) => [String(l._id), l.nombre || ""]),
  );

  const existentes = (catalogos.alumnos || []).map((a) => ({
    ID: encodeId(String(a._id)),
    Nombre: a.nombre || "",
    "Apellido Paterno": a.apellidoPaterno || "",
    "Apellido Materno": a.apellidoMaterno || "",
    Correo: a.correo || "",
    Teléfono: a.telefono || "",
    Celular: a.celular || "",
    Escuela: escuelaNombrePorId.get(idStr(a.datosAlumno?.escuelaId)) || "",
    Grupo: grupoNombrePorId.get(idStr(a.datosAlumno?.grupoEscuelaId)) || "",
    Matrícula: a.datosAlumno?.matricula || "",
    "Lista Individual":
      listaNombrePorId.get(idStr(a.datosAlumno?.listaId)) || "",
    "Nivel Prepare": a.datosAlumno?.nivelPrepare || "",
    "Nivel Inglés":
      a.datosAlumno?.nivelIngles === undefined ||
      a.datosAlumno?.nivelIngles === null
        ? ""
        : a.datosAlumno.nivelIngles,
  }));
  const hojaExistentes =
    existentes.length > 0
      ? XLSX.utils.json_to_sheet(existentes, { header: cabecera })
      : XLSX.utils.json_to_sheet([{ ID: "(no hay alumnos registrados)" }]);
  hojaExistentes["!cols"] = hojaPrincipal["!cols"];
  if (existentes.length > 0) forzarColumnaTexto(hojaExistentes, COL_MATRICULA);
  XLSX.utils.book_append_sheet(wb, hojaExistentes, "Existentes");

  // Para Escuelas mostramos Clave primero (más usado) y luego Nombre.
  // El validador acepta cualquiera de los dos.
  const escuelas = (catalogos.escuelas || []).map((e) => ({
    Clave: e.clave || "",
    Nombre: e.nombre,
  }));
  const hojaEscuelas =
    escuelas.length > 0
      ? XLSX.utils.json_to_sheet(escuelas)
      : XLSX.utils.json_to_sheet([{ Clave: "(no hay escuelas activas)" }]);
  hojaEscuelas["!cols"] = [{ wch: 16 }, { wch: 32 }];
  XLSX.utils.book_append_sheet(wb, hojaEscuelas, "Escuelas");

  // Para grupos mostramos junto a qué escuela pertenecen para evitar
  // ambigüedad cuando hay grupos con el mismo nombre en distintas escuelas.
  const escuelaPorId = new Map();
  for (const e of catalogos.escuelas || [])
    escuelaPorId.set(e._id.toString(), e.nombre);

  const grupos = (catalogos.grupos || []).map((g) => ({
    Grupo: g.nombre,
    Escuela: escuelaPorId.get(g.escuelaId?.toString()) || "",
  }));
  const hojaGrupos =
    grupos.length > 0
      ? XLSX.utils.json_to_sheet(grupos)
      : XLSX.utils.json_to_sheet([{ Grupo: "(no hay grupos activos)" }]);
  hojaGrupos["!cols"] = [{ wch: 22 }, { wch: 32 }];
  XLSX.utils.book_append_sheet(wb, hojaGrupos, "Grupos");

  const listas = (catalogos.listas || []).map((l) => ({ Nombre: l.nombre }));
  const hojaListas =
    listas.length > 0
      ? XLSX.utils.json_to_sheet(listas)
      : XLSX.utils.json_to_sheet([{ Nombre: "(no hay listas registradas)" }]);
  hojaListas["!cols"] = [{ wch: 40 }];
  XLSX.utils.book_append_sheet(wb, hojaListas, "Listas");

  return wb;
};

const validarFila = (fila, catalogos, _indice, contexto) => {
  const errores = [];
  const nombre = fila["Nombre"] ? String(fila["Nombre"]).trim() : "";
  const apellidoPaterno = fila["Apellido Paterno"]
    ? String(fila["Apellido Paterno"]).trim()
    : "";
  const apellidoMaterno = fila["Apellido Materno"]
    ? String(fila["Apellido Materno"]).trim()
    : "";
  const correo = fila["Correo"] ? String(fila["Correo"]).trim() : "";
  const telefono = fila["Teléfono"]
    ? String(fila["Teléfono"]).trim()
    : fila["Telefono"]
      ? String(fila["Telefono"]).trim()
      : "";
  const celular = fila["Celular"] ? String(fila["Celular"]).trim() : "";
  const escuelaNombre = fila["Escuela"] ? String(fila["Escuela"]).trim() : "";
  const grupoNombre = fila["Grupo"] ? String(fila["Grupo"]).trim() : "";
  const matricula = fila["Matrícula"]
    ? String(fila["Matrícula"]).trim()
    : fila["Matricula"]
      ? String(fila["Matricula"]).trim()
      : "";
  const listaNombre = fila["Lista Individual"]
    ? String(fila["Lista Individual"]).trim()
    : fila["Lista"]
      ? String(fila["Lista"]).trim()
      : "";
  const nivelPrepare = fila["Nivel Prepare"]
    ? String(fila["Nivel Prepare"]).trim()
    : "";
  const nivelInglesRaw =
    fila["Nivel Inglés"] !== undefined
      ? fila["Nivel Inglés"]
      : fila["Nivel Ingles"];
  const idEncoded = fila["ID"] ? String(fila["ID"]).trim() : "";

  let existente = null;
  if (idEncoded) {
    const decoded = decodeId(idEncoded);
    if (!decoded) {
      errores.push({ campo: "ID", motivo: `"${idEncoded}" no es válido` });
    } else {
      existente = (catalogos.alumnos || []).find(
        (a) => String(a._id) === String(decoded),
      );
      if (!existente) {
        errores.push({
          campo: "ID",
          motivo: `"${idEncoded}" no corresponde a ningún alumno existente`,
        });
      }
    }
  }

  if (!nombre) errores.push({ campo: "Nombre", motivo: "está vacío" });
  if (!apellidoPaterno)
    errores.push({ campo: "Apellido Paterno", motivo: "está vacío" });
  if (!escuelaNombre)
    errores.push({ campo: "Escuela", motivo: "está vacío (obligatorio)" });
  if (!matricula)
    errores.push({ campo: "Matrícula", motivo: "está vacío (obligatorio)" });

  if (correo) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(correo))
      errores.push({ campo: "Correo", motivo: "no es un correo válido" });
  }

  let nivelIngles = null;
  if (nivelInglesRaw !== undefined && nivelInglesRaw !== "") {
    const n = Number(nivelInglesRaw);
    if (Number.isNaN(n)) {
      errores.push({ campo: "Nivel Inglés", motivo: "debe ser un número" });
    } else {
      nivelIngles = n;
    }
  }

  // Resolver escuela: aceptar clave O nombre (case-insensitive).
  // Se intenta primero por clave, luego por nombre.
  let escuelaId = null;
  let escuelaResuelta = null;
  if (escuelaNombre) {
    const llave = escuelaNombre.toLowerCase();
    escuelaResuelta =
      (catalogos.escuelas || []).find(
        (e) => (e.clave || "").trim().toLowerCase() === llave,
      ) ||
      (catalogos.escuelas || []).find(
        (e) => (e.nombre || "").trim().toLowerCase() === llave,
      );
    if (!escuelaResuelta) {
      errores.push({
        campo: "Escuela",
        motivo: `"${escuelaNombre}" no existe (puedes usar la clave o el nombre — revisa la hoja "Escuelas")`,
      });
    } else {
      escuelaId = escuelaResuelta._id;
      if (!existente && !escuelaResuelta.tipoDeClienteId) {
        errores.push({
          campo: "Escuela",
          motivo:
            "esta escuela no tiene tipo de cliente configurado; edítala primero",
        });
      }
    }
  }

  let grupoEscuelaId = null;
  let grupoResuelto = null;
  if (grupoNombre) {
    if (!escuelaId) {
      errores.push({
        campo: "Grupo",
        motivo: "no se puede validar sin escuela",
      });
    } else {
      const llave = grupoNombre.toLowerCase();
      grupoResuelto = (catalogos.grupos || []).find(
        (g) =>
          (g.nombre || "").trim().toLowerCase() === llave &&
          g.escuelaId?.toString() === escuelaId.toString(),
      );
      if (!grupoResuelto) {
        errores.push({
          campo: "Grupo",
          motivo: `"${grupoNombre}" no existe en la escuela "${escuelaNombre}"`,
        });
      } else {
        grupoEscuelaId = grupoResuelto._id;
      }
    }
  }

  const correoPropio = (existente?.correo || "").trim().toLowerCase();
  const matriculaPropia = (existente?.datosAlumno?.matricula || "")
    .trim()
    .toLowerCase();

  if (correo) {
    const llave = correo.toLowerCase();
    if (
      llave !== correoPropio &&
      (catalogos.correosExistentes || []).includes(llave)
    ) {
      errores.push({
        campo: "Correo",
        motivo: "ya existe un alumno con ese correo",
      });
    }
    if (contexto.clavesYaUsadas.has("correo:" + llave)) {
      errores.push({
        campo: "Correo",
        motivo: `correo repetido en el archivo (también en la fila ${contexto.clavesYaUsadas.get("correo:" + llave)})`,
      });
    } else {
      contexto.clavesYaUsadas.set(
        "correo:" + llave,
        (fila["__rowNum__"] ?? 0) + 1,
      );
    }
  }

  let listaId = null;
  let listaResuelta = null;
  if (listaNombre) {
    const llave = listaNombre.toLowerCase();
    listaResuelta = (catalogos.listas || []).find(
      (l) => (l.nombre || "").trim().toLowerCase() === llave,
    );
    if (!listaResuelta) {
      errores.push({
        campo: "Lista Individual",
        motivo: `"${listaNombre}" no existe (revisa la hoja "Listas")`,
      });
    } else {
      listaId = listaResuelta._id;
    }
  }

  if (matricula) {
    const llave = matricula.toLowerCase();
    if (
      llave !== matriculaPropia &&
      (catalogos.matriculasExistentes || []).includes(llave)
    ) {
      errores.push({
        campo: "Matrícula",
        motivo: "ya existe un alumno con esa matrícula",
      });
    }
    if (contexto.clavesYaUsadas.has("matricula:" + llave)) {
      errores.push({
        campo: "Matrícula",
        motivo: `matrícula repetida en el archivo (también en la fila ${contexto.clavesYaUsadas.get("matricula:" + llave)})`,
      });
    } else {
      contexto.clavesYaUsadas.set(
        "matricula:" + llave,
        (fila["__rowNum__"] ?? 0) + 1,
      );
    }
  }

  if (errores.length > 0) {
    return { ok: false, errores };
  }

  const datos = {
    nombre,
    apellidoPaterno,
    apellidoMaterno,
    correo,
    telefono,
    celular,
    escuelaId,
    escuelaNombre: escuelaResuelta?.nombre || "",
    grupoEscuelaId,
    grupoNombre: grupoResuelto?.nombre || "",
    matricula,
    listaId,
    listaNombre: listaResuelta?.nombre || "",
    nivelPrepare,
    nivelIngles,
  };

  if (!existente) {
    return { ok: true, accion: "crear", datos };
  }

  const escuelaPrev = (catalogos.escuelas || []).find(
    (e) => String(e._id) === idStr(existente.datosAlumno?.escuelaId),
  );
  const grupoPrev = (catalogos.grupos || []).find(
    (g) => String(g._id) === idStr(existente.datosAlumno?.grupoEscuelaId),
  );
  const listaPrev = (catalogos.listas || []).find(
    (l) => String(l._id) === idStr(existente.datosAlumno?.listaId),
  );

  const nivelInglesPrev =
    existente.datosAlumno?.nivelIngles === undefined ||
    existente.datosAlumno?.nivelIngles === null
      ? null
      : Number(existente.datosAlumno.nivelIngles);

  const valoresAnteriores = {
    nombre: (existente.nombre || "").trim(),
    apellidoPaterno: (existente.apellidoPaterno || "").trim(),
    apellidoMaterno: (existente.apellidoMaterno || "").trim(),
    correo: (existente.correo || "").trim(),
    telefono: String(existente.telefono || "").trim(),
    celular: String(existente.celular || "").trim(),
    escuelaNombre: escuelaPrev?.nombre || "",
    grupoNombre: grupoPrev?.nombre || "",
    matricula: (existente.datosAlumno?.matricula || "").trim(),
    listaNombre: listaPrev?.nombre || "",
    nivelPrepare: (existente.datosAlumno?.nivelPrepare || "").trim(),
    nivelIngles: nivelInglesPrev,
  };

  const cambios = [];
  if (valoresAnteriores.nombre.toUpperCase() !== nombre.toUpperCase())
    cambios.push("nombre");
  if (
    valoresAnteriores.apellidoPaterno.toUpperCase() !==
    apellidoPaterno.toUpperCase()
  )
    cambios.push("apellidoPaterno");
  if (
    valoresAnteriores.apellidoMaterno.toUpperCase() !==
    apellidoMaterno.toUpperCase()
  )
    cambios.push("apellidoMaterno");
  if (valoresAnteriores.correo.toLowerCase() !== correo.toLowerCase())
    cambios.push("correo");
  if (valoresAnteriores.telefono !== telefono) cambios.push("telefono");
  if (valoresAnteriores.celular !== celular) cambios.push("celular");
  if (
    idStr(existente.datosAlumno?.escuelaId) !== String(escuelaId || "")
  )
    cambios.push("escuelaNombre");
  if (
    idStr(existente.datosAlumno?.grupoEscuelaId) !==
    String(grupoEscuelaId || "")
  )
    cambios.push("grupoNombre");
  if (valoresAnteriores.matricula !== matricula) cambios.push("matricula");
  if (idStr(existente.datosAlumno?.listaId) !== String(listaId || ""))
    cambios.push("listaNombre");
  if (valoresAnteriores.nivelPrepare !== nivelPrepare)
    cambios.push("nivelPrepare");
  if (nivelInglesPrev !== nivelIngles) cambios.push("nivelIngles");

  if (cambios.length === 0) {
    return {
      ok: true,
      accion: "sinCambios",
      idExistente: String(existente._id),
      datos,
      valoresAnteriores,
    };
  }

  return {
    ok: true,
    accion: "editar",
    idExistente: String(existente._id),
    datos,
    cambios,
    valoresAnteriores,
  };
};

const instrucciones = [
  <>
    <b>Descarga la plantilla.</b> El archivo trae varias hojas:
    <ul style={{ marginTop: 4, marginBottom: 0, paddingLeft: 18 }}>
      <li>
        <b>Alumnos</b> — la hoja principal donde escribes los datos a importar.
      </li>
      <li>
        <b>Existentes</b> — contiene tus alumnos actuales con todos sus datos
        (incluida la <b>Matrícula</b>) y su <b>ID</b>. Cópialos a la hoja{" "}
        <b>Alumnos</b> si quieres editarlos.
      </li>
      <li>
        <b>Escuelas, Grupos, Listas</b> — catálogos de referencia para que sepas
        qué valores son válidos.
      </li>
    </ul>
  </>,
  <>
    Para <b>crear</b> un alumno: deja la columna <b>ID</b> vacía y llena el
    resto. La <b>Matrícula</b> es obligatoria.
  </>,
  <>
    Para <b>editar</b> un alumno: copia su fila <b>completa</b> desde la hoja{" "}
    <b>Existentes</b> a la hoja <b>Alumnos</b> (con el ID incluido) y modifica
    solo los campos que quieras cambiar. <b>Puedes cambiar la matrícula</b>.
  </>,
  <>
    <b>Importante al editar:</b> la fila reemplaza los datos del alumno. Si dejas
    una celda <b>en blanco</b>, ese dato se <b>borrará</b>. Por eso conviene
    copiar la fila completa desde <b>Existentes</b> y cambiar únicamente lo
    necesario.
  </>,
  <>
    <b>La columna Matrícula debe ser SIEMPRE texto.</b> La plantilla ya viene con
    esa columna formateada como texto; no la cambies a número para que no se
    pierdan los ceros iniciales (ej. <code>0123</code>) ni se generen errores.
  </>,
  <>
    En la tabla de vista previa, las filas a <b>Editar</b> muestran el valor
    nuevo y debajo, en gris tachado, el valor anterior.
  </>,
  <>
    Si hay errores, podrás descargar <code>errores.xlsx</code> para revisarlos.
  </>,
  <>
    Haz clic en <b>Importar</b> para aplicar los cambios.
  </>,
];

const ImportarAlumnos = (props) => {
  const { ventaOnline } = props;
  const [crearUsuariosEcommerce, setCrearUsuariosEcommerce] = useState(false);
  const [modalResumenVisible, setModalResumenVisible] = useState(false);
  const [resumenEcommerce, setResumenEcommerce] = useState(null);

  const atras = () => {
    if (props.location?.state?.volverA) {
      props.history.replace(props.location.state.volverA);
    } else {
      props.history.goBack();
    }
  };

  // Solo se ofrece generar accesos de ecommerce si la empresa tiene activado
  // el complemento de venta online (ecommerce).
  const controlesEcommerce = ventaOnline ? (
    <Alert
      message="Accesos para Ecommerce"
      description={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginTop: "8px",
          }}
        >
          <Switch
            checked={crearUsuariosEcommerce}
            onChange={setCrearUsuariosEcommerce}
          />
          <span>
            Generar automáticamente cuentas de ecommerce para los nuevos alumnos
            (<b>Usuario y Contraseña:</b> Matrícula).
          </span>
        </div>
      }
      type="info"
      showIcon
    />
  ) : null;

  const onImportSuccess = (resData) => {
    // Si se generaron accesos de ecommerce, mostramos el resumen en un modal
    // y dejamos que el cierre del modal navegue hacia atrás.
    if (ventaOnline && crearUsuariosEcommerce && resData?.resumenEcommerce) {
      setResumenEcommerce(resData.resumenEcommerce);
      setModalResumenVisible(true);
      return true;
    }
    return false;
  };

  const cerrarModalResumen = () => {
    setModalResumenVisible(false);
    setResumenEcommerce(null);
    atras();
  };

  return (
    <>
      <ImportadorExcelGenerico
        {...props}
        titulo="Importar / Actualizar Alumnos"
        nombreEntidadPlural="alumnos"
        endpointDatosImportar="alumnos/datosParaImportarAlumnos"
        endpointImportar="alumnos/importarAlumnos"
        nombrePlantilla="plantillaAlumnos.xlsx"
        construirPlantilla={construirPlantilla}
        validarFila={validarFila}
        columnasPreview={columnasPreview}
        instrucciones={instrucciones}
        controlesExtra={controlesEcommerce}
        onImportSuccess={onImportSuccess}
        prepararPayloadExtra={() => ({
          crearUsuariosEcommerce: ventaOnline && crearUsuariosEcommerce,
        })}
        permitirEdicion
        mostrarSwitchSoloCambios
      />

      <ResumenEcommerceModal
        visible={modalResumenVisible}
        resumen={resumenEcommerce}
        cerrarModal={cerrarModalResumen}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  ventaOnline: state.empresa.ventaOnline,
});

export default connect(mapStateToProps)(ImportarAlumnos);
